<template>
    <div class="transfer-dialog">
          <el-dialog
            :visible="transferVisible"
            width="40%"
            title="转移"
            destroy-on-close
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            @close="handleClose">
              <dc-form ref='dcForm' refName="transferForm" :row="formData" :config="FIELDS"
                    :col="2" @data-changed="handleFormDataChange"
                    labelWidth="120px" class="add-customer-form">
                </dc-form>
            <span slot="footer">
                <el-button size="mini" @click="handleClose">取 消</el-button>
                <lots-button type="primary" size="mini" @click="handleConfirm">确 认</lots-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, onMounted, computed } from '@vue/composition-api';
import lotsButton from '@/components/lots/lotsButton';
import dcForm from '@/modules/mdm/components/form/Index.vue';
import store from '@/store';
import _ from 'lodash';
import { tableConfig } from './config.js';
export default {
    components: {
        lotsButton,
        dcForm
    },
    props: {
        row: {
            type: Object,
            default: () => { return {}; }
        }
    },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const { emit } = setupContext;
        const formData = ref({
            ownerName: '',
            ownerCode: ''
        });
        const transferVisible = ref(false);
        const config = reactive(tableConfig);
        const FIELDS = computed(() => {
            return config.fields;
        });
        const handleConfirm = () => {
            setupContext.refs.dcForm.$refs.transferForm.validate((valid) => {
                if (valid) {
                    emit('confirm', formData.value);
                }
            });
        };
        // eslint-disable-next-line complexity
        const handleFormDataChange = ({ data, form, itemSetting }) => {
            formData.value = Object.assign(formData.value, form);
        };
        const show = () => {
            setupContext.root.$nextTick(() => {
                transferVisible.value = true;
                // 重置表单数据
                formData.value = {
                    ownerName: '',
                    ownerCode: ''
                };
            });
        };
        const handleClose = () => {
            transferVisible.value = false;
            // 重置表单数据
            formData.value = {
                ownerName: '',
                ownerCode: ''
            };
        };
        return {
            transferVisible,
            formData,
            FIELDS,
            handleFormDataChange,
            handleConfirm,
            handleClose,
            show
        };
    }
};
</script>
<style lang="less">

</style>
